import type { SVGProps } from "react";
export interface ToothIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ToothIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ToothIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 8.5c0-1.548-.444-2.912-1.196-3.865-.732-.927-1.786-1.51-3.178-1.51-.69 0-1.597.368-2.442.851l-.036.02 1.601 1.068.093.07a1.126 1.126 0 0 1-1.242 1.861l-.098-.058-3-2.001-.08-.058-.001-.001-.016-.012-.07-.054c-.064-.048-.159-.12-.28-.205a13 13 0 0 0-.988-.63c-.845-.483-1.752-.85-2.442-.851-1.392 0-2.447.583-3.18 1.51-.751.953-1.195 2.317-1.195 3.865 0 .555.13 1.395.375 2.444.24 1.03.576 2.196.948 3.375a114 114 0 0 0 2.141 6.091l.047.1c.127.22.367.364.643.364.3 0 .573-.175.696-.45l1.236-2.746a3.059 3.059 0 0 1 5.579 0l1.234 2.747c.124.274.397.45.698.45a.73.73 0 0 0 .69-.465l.45-1.198a107 107 0 0 0 1.691-4.893c.372-1.179.706-2.344.947-3.375.244-1.049.375-1.889.375-2.444m2.25 0c0 .823-.18 1.868-.434 2.956a50 50 0 0 1-.992 3.54c-.762 2.42-1.656 4.83-2.185 6.217a2.98 2.98 0 0 1-2.792 1.912 3.01 3.01 0 0 1-2.748-1.777L12.737 18.6a.809.809 0 0 0-1.418-.102l-.055.102-1.237 2.747a3.01 3.01 0 0 1-2.748 1.777 2.98 2.98 0 0 1-2.7-1.698l-.092-.214a116 116 0 0 1-2.185-6.217 50 50 0 0 1-.993-3.54C1.055 10.368.875 9.323.875 8.5c0-1.952.557-3.837 1.68-5.26C3.698 1.794 5.393.876 7.5.876c1.311 0 2.654.631 3.559 1.148.362.207.68.416.94.592.26-.176.58-.384.943-.592C13.847 1.506 15.19.875 16.5.875c2.107 0 3.803.918 4.946 2.366 1.123 1.422 1.678 3.307 1.678 5.259Z"
      />
    </svg>
  );
}
